import { render, staticRenderFns } from "./LandingCarousel.vue?vue&type=template&id=0176de2e&scoped=true&lang=html&"
import script from "./LandingCarousel.vue?vue&type=script&lang=js&"
export * from "./LandingCarousel.vue?vue&type=script&lang=js&"
import style0 from "./LandingCarousel.vue?vue&type=style&index=0&id=0176de2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0176de2e",
  null
  
)

export default component.exports